module.exports = __webpack_public_path__ + "static/media/landingPageVideo2FR.76cbc577.png";